export enum DroneStatusType {
    IDLE = 'IDLE',
    NOT_ACTIVE = 'NOT_ACTIVE',
	ACTIVE = 'ACTIVE',
	STANDBY = 'STANDBY',
	ASSIGNED = 'ASSIGNED',
	SENT_FOR_AUTHORIZATION = 'SENT_FOR_AUTHORIZATION',
	AUTHORIZED = 'AUTHORIZED',
	NOT_AUTHORIZED = 'NOT_AUTHORIZED',
	MISSION = 'MISSION',
	BREAK = 'BREAK',
	RTL = 'RTL',
	LAND = 'LAND',
	NOT_USED = 'NOT_USED',
	ERROR = 'ERROR',
	OFFLINE = 'OFFLINE',
	EMERGENCY = 'EMERGENCY',
	ARCHIVE = 'ARCHIVE',
	// Firmware (flightdispatcher DroneStates) — держим в синхроне с бэкендовым DroneStatus.
	UPDATE_SOFTWARE_REQUIRED = 'UPDATE_SOFTWARE_REQUIRED',
	UPLOAD = 'UPLOAD',
	MISSION_COMPLETE = 'MISSION_COMPLETE',
	CLOSE = 'CLOSE',
	EMERGENCY_LAND = 'EMERGENCY_LAND',
	MANUAL_CONTROL = 'MANUAL_CONTROL',
}

/** UI label for a drone status — API value may differ (e.g. UPDATE_SOFTWARE_REQUIRED). */
export const formatDroneStatusLabel = (status?: DroneStatusType | string | null): string => {
  if (status === DroneStatusType.UPDATE_SOFTWARE_REQUIRED) return 'UPDATE REQUIRED';
  return status ?? '';
};
